'use strict';
var LayoutType;
(function (LayoutType) {
    LayoutType["List"] = "list";
    LayoutType["Grid"] = "grid";
})(LayoutType || (LayoutType = {}));
export default LayoutType;
